export const SERVICE_NAMES = {
  GENERAL_TASK: 'General Task',
  TIRE_DISPOSAL: 'Disposal Fee',
  TIRE_INSTALL: 'Tire Install',
  TIRE_PURCHASE: 'Tire Purchase',
  TIRE_PREMOUNTED: 'Pre-Mounted Tire',
  TIRE_DELIVERY: 'Tire Delivery',
  TIRE_DROP_OFF: 'Tire Drop Off', //we cannot remove due to the longterm use of this name in the system
  TPMS_SERVICE: 'TPMS Service',
  TIRE_ROTATION: 'Tire Rotation',
  REWORK: 'Rework',
  GENERIC_TIRE: 'Generic Tire',
  GENERIC_ITEM: 'Generic Item',
  STATE_TIRE_FEE: 'State Tire Fee',
  WIPER_BLADE: 'Wiper Blade',
  TPMS_SENSOR: 'TPMS Sensor',
  MINIMUM_SERVICE_CHARGE: 'Minimum Service Charge',
  INSPECTION: 'Inspection',
}

export const GENERIC_SERVICE = [
  SERVICE_NAMES.GENERIC_ITEM,
  SERVICE_NAMES.GENERIC_TIRE,
]

export const INSTALLATION_SERVICES = [
  //! keep up-to-date with backend
  SERVICE_NAMES.TIRE_INSTALL,
  SERVICE_NAMES.TIRE_PREMOUNTED,
  SERVICE_NAMES.TIRE_ROTATION,
  SERVICE_NAMES.TPMS_SERVICE,
]

//these are the services which we can actively schedule from within
//the cs portal. The are copied on the backend as well
export const ACTIVE_SERVICES = [
  SERVICE_NAMES.TIRE_INSTALL,
  SERVICE_NAMES.TIRE_PREMOUNTED,
  SERVICE_NAMES.TIRE_ROTATION,
  SERVICE_NAMES.TPMS_SERVICE,
  SERVICE_NAMES.TIRE_DELIVERY,
]

export enum CATEGORIES {
  LABOR = 'labor',
  DISPOSAL = 'disposal',
  ACCESSORIES = 'accessories',
  TIRES = 'tires',
  FEE = 'fee',
  WIPERS = 'wipers', //requested category from Miles / accounting
}

export const TIRE_INSTALL_TIRE_RACK_NAMES = {
  WHEELS_ONLY: 'WheelsOnly',
  TIRE_MOUNTING: 'TireMounting',
}
